export default [{"url":"https://test-inc-0.api.invexone.com","name":"HQ","port":"6509","isStore":true,"isHQ":true}]